if (!customElements.get('dm-account-menu')) {
    customElements.define('dm-account-menu', class extends HTMLElement {
        connectedCallback() {
            this.controller = new AbortController();
            const options = { signal: this.controller.signal };
            const details = this.querySelector('details');
            const summary = details.querySelector('summary');
            this.addEventListener('pointerenter', (event) => {
                if (event.pointerType === 'mouse') details.open = true;
            }, options);
            this.addEventListener('pointerleave', (event) => {
                if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) details.open = false;
            }, options);
            this.addEventListener('focusin', (event) => {
                if (event.target === summary && summary.matches(':focus-visible') && !this.restoringFocus) details.open = true;
            }, options);
            this.addEventListener('focusout', (event) => {
                if (!this.contains(event.relatedTarget)) details.open = false;
            }, options);
            this.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && details.open) {
                    event.preventDefault();
                    event.stopPropagation();
                    details.open = false;
                    this.restoringFocus = true;
                    summary.focus();
                    this.restoringFocus = false;
                }
            }, options);
            document.addEventListener('pointerdown', (event) => {
                if (!this.contains(event.target)) details.open = false;
            }, options);
        }
        disconnectedCallback() {
            this.controller.abort();
        }
    });
}
